import React, { ReactElement } from 'react';
import { ComponentType, Props } from './';

const ContentBlock: ComponentType = ({ contentBlocks }: Props): ReactElement => (
  <>
    {contentBlocks}
  </>
);

export { ContentBlock };
